import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import FleetDriverListScreen from './screens/FleetDriverListScreen';
import EditDriverScreen from './screens/EditDriverScreen';
import FleetDriverDetailScreen from './screens/FleetDriverDetailScreen';

function FleetDriver(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<FleetDriverListScreen />} />
                    <Route path={"/add"} element={<EditDriverScreen />} />
                    <Route path=":driverId" element={<FleetDriverDetailScreen />} />
                    <Route path={"/:driverId/edit"} element={<EditDriverScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default FleetDriver;
